import { normalizeText } from "@educaplay/core";

const SPECIAL_CHARACTERS = [".", ",", ";", ":", "=", "*", "+", "-", "{", "}", "[", "]", "¿", "?", "¡", "!", "(", ")", "/", "|", "\\", "\""];

export class Decoder {
    constructor(config = {}) {
        this.keySensitive = config.keySensitive ?? false;
        this.pile = []
    }

    encode(entryStr) {
        const words = entryStr.split(" ");
        const response = [];
        words.forEach(word => {
            const encodeWord = this._encodeWord(word);

            response.push(encodeWord);

            this.pile.push({
                encode: encodeWord,
                decode: word
            });
        });

        return response.join(" ");
    }

    decode(entryStr) {
        const words = entryStr.split(" ");
        const result = words.map(word => {
            const encodeWord = this._encodeWord(word);
            const index = this.pile.findIndex(item => item.encode === encodeWord);

            if (index === -1) {
                return word;
            }

            const decodeWord = this.pile[index].decode;

            this.pile.splice(index, 1);

            return decodeWord
        });

        return result.join(" ");
    }

    _encodeWord(str) {
        if (this.keySensitive) {
            return normalizeText(str);
        }

        const apostropheNormalized = str.replace(/[`'´]/g, "'");
        const normalized = apostropheNormalized.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
        const characters = normalizeText(normalized).split("");

        return characters.filter(char => {
            return !SPECIAL_CHARACTERS.includes(char)
        }).join("");
    }
}